import React from "react";
import SEO from "./SEO";

function CaseStudies() {
return (
    <section id="case-studies" className="case-studies" aria-labelledby="case-studies-title">
        <SEO
            title="Case Studies - Sukun Cloud Consulting"
            description="Explore our client success stories and case studies showcasing our expertise in Cloud Consulting and DevOps solutions."
            keywords={[
                "Case Studies",
                "Client Success",
                "Cloud Consulting",
                "DevOps",
                "Sukun",
                "Infrastructure Scaling",
                "Cloud Cost Optimization",
                "System Reliability",
                "CI/CD Pipelines",
                "Cloud-Native Architecture",
                "Performance Optimization",
                "Security Best Practices",
                "Private Cloud Solutions",
                "Data Management",
                "Disaster Recovery",
                "Team Training",
                "Process Documentation",
                "Uptime SLA",
                "Feedback Integration",
                "Live Cluster Migration",
                "Automation Systems"
            ]}
        />
        <h2 id="case-studies-title">Case Studies</h2>
        <ul>
            {[
                { icon: "🚀", text: "Scaled their infrastructure to handle +500M email traffic with RKE2 and GCE." },
                { icon: "📈", text: "Reduced cloud costs by 40% with optimized GCP architecture." },
                { icon: "🔍", text: "Improved system reliability with GitOps and monitoring solutions." },
                { icon: "🛠️", text: "Implemented CI/CD pipelines for faster deployment cycles." },
                { icon: "🌐", text: "Migrated legacy systems to a modern cloud-native architecture." },
                { icon: "💡", text: "Enhanced application performance with Redis and MongoDB optimizations." },
                { icon: "🔒", text: "Strengthened security posture with best practices and compliance checks." },
                { icon: "🤝", text: "Collaborated with cross-functional teams to ensure seamless integration." },
                { icon: "🌍", text: "Built a fully private cloud solution." },
                { icon: "🗂️", text: "Streamlined data management with ClickHouse and Kafka." },
                { icon: "🛡️", text: "Implemented disaster recovery and backup solutions." },
                { icon: "🧑‍💻", text: "Trained client teams on best practices and tool usage." },
                { icon: "📝", text: "Documented all processes and configurations for future reference." },
                { icon: "📈", text: "Achieved a 99.9% uptime SLA for all deployed systems." },
                { icon: "💬", text: "Engaged in regular communication with clients for feedback and improvements." },
                { icon: "📅", text: "Successfully migrated live MongoDB clusters with over 10 clusters and 15 shards each." },
                { icon: "🔄", text: "Built automation systems." }
            ].map((item, index) => (
                <li key={index}>
                    <strong>{item.icon}</strong> {item.text}
                </li>
            ))}
        </ul>
    </section>
);
}

export default CaseStudies;